import { render, staticRenderFns } from "./person_data.vue?vue&type=template&id=036a98bc&scoped=true"
import script from "./person_data.vue?vue&type=script&lang=js"
export * from "./person_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a98bc",
  null
  
)

export default component.exports